import { EnumPreventivoDTOStato } from '@framework/api-client/api/backoffice/schemas/enumPreventivoDTOStato.ts';
import { type ISubmissionQuote } from './ISubmissionQuote.ts';

export class SubmissionQuoteLogic {
  static requiresAcceptance(quote: ISubmissionQuote) {
    return quote.stato === EnumPreventivoDTOStato.ATTESA_APPROVAZIONE;
  }
}
